import { Injectable } from '@angular/core';
import { BaseDataService } from './base-data.service';
import { CryptoService } from './crypto.service';

@Injectable({
    providedIn: 'root'
})
export class UserRightsService {
    constructor(protected baseDataService: BaseDataService){
    }

    LoadUserRights() {
        this.baseDataService.GetData('user', 'getUserRights', null)
          .subscribe(userRights => {
              const encrypted = CryptoService.Encrypt(userRights);
              sessionStorage.setItem('yt-user-rights', encrypted);
            })
    }

  GetUserRightValue(model: string, action: string) {
    const encrypted = sessionStorage.getItem('yt-user-rights');
      if (!encrypted) return false;

      const userRightsData = CryptoService.Decrypt(encrypted);

      if (!userRightsData) return false;
      if (!userRightsData.Values[model]) return false;

      return userRightsData.Values[model][action];
    }
}
